export default __webpack_public_path__ + "static/media/key.98062164.svg";